import type { NextPage } from 'next';
import Link from 'next/link';
import styles from './bread-crumbs.module.scss';

export type BreadCrumbsBlogType = {
  item: string;
};

const BreadCrumbsBlog: NextPage<BreadCrumbsBlogType> = ({ item }) => {
  return (
    <nav className={[styles.breadcrumbs].join(' ')} aria-label="breadcrumb">
      <div className="container">
        <ol className={styles.list}>
          <li className={styles.item}>
            <Link href="/" className={styles.link}>
              Home
            </Link>
          </li>
          <span className={styles.separator}>{'>'}</span>
          <li className={styles.item}>
            <Link href="/blog" className={styles.link}>
              Blog
            </Link>
          </li>
          <span className={styles.separator}>{'>'}</span>
          <span className={styles.linkGray}>{item}</span>
        </ol>
      </div>
    </nav>
  );
};

export default BreadCrumbsBlog;
